<div class="ship-details" id="js-ship-details">
    <div [class.moz]="shouldFixPrint()" class="ship-details-content">
        <ng-container [ngTemplateOutlet]="shipmentStatus"></ng-container>
        <ng-container [ngTemplateOutlet]="restrictedZipCodeNotification"></ng-container>

        <div [class.expanded]="isShowTrackingDetailsTable" class="summary">
            <div class="summary-section no-print">
                <ng-container [ngTemplateOutlet]="trackingDetails"></ng-container>
            </div>
            <div class="summary-section score-card">
                <ng-container
                        *ngIf="environment?.feature.deliveryDefense && user?.CountryCode === 'US' && !!shipmentPackage?.DDScore?.score">
                    <upsc-delivery-defense-score-summary
                            [addressType]="shipmentPackage?.DDScore?.resiComFlag | lowercase"
                            [address]="shipmentPackage?.ShipTo"
                            [value]="shipmentPackage?.DDScore?.score"></upsc-delivery-defense-score-summary>
                </ng-container>
            </div>
        </div>

        <div class="general-shipment-info">
            <ng-container [ngTemplateOutlet]="shipmentDetails"></ng-container>
            <ng-container [ngTemplateOutlet]="shipmentInformation"></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="commodities"></ng-container>

        <div *ngIf="!isTrackedShipment" class="tracked-shipment-info">
            <ng-container [ngTemplateOutlet]="paymentInformation"></ng-container>
            <ng-container [ngTemplateOutlet]="alternativeDeliveryLocation"></ng-container>
            <ng-container [ngTemplateOutlet]="specialServices"></ng-container>
        </div>

        <ng-container [ngTemplateOutlet]="notifications"></ng-container>
        
        <div *ngIf="!isMobileWebView && (!!labelImage || !!labelPdf)" class="label-container no-print">
            <upsc-ship-label #shipLabel
                             [labelImage]="labelImage"
                             [labelPdf]="labelPdf"
                             [podPdf]="podPdf"
                             [shouldPrintLabel]="shouldPrintLabel"></upsc-ship-label>
        </div>
        <div class="only-print">
            <ng-container [ngTemplateOutlet]="trackingDetails"></ng-container>
        </div>
    </div>
</div>

<ng-template #shipmentStatus>
    <div *ngIf="handheldSignature" class="section shipment-status">
        <div class="section-header">
            <h4 class="section-title">Shipment Status</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section-content">
            <div class="content-items">
                <div class="content-item handheld-signature">
                    <picture class="signature-image">
                        <img [alt]="handheldSignature.SignedBy"
                             [src]="'data:image/png;base64, ' + handheldSignature.ImageEncodedByte | safe:'resourceUrl'">
                    </picture>
                    <div class="signature-caption">
                        Signed
                        <span class="signed-at">at {{ handheldSignature.Location }}</span>
                        <span class="signed-by">by {{ handheldSignature.SignedBy }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #trackingDetails>
    <div [ngClass]="{ 'no-print' : !isShowTrackingDetailsTable }" class="section tracking-details ">
        <div class="section-header">
            <h4 class="section-title">{{'TrackingDetails'|translate}}</h4>
        </div>
        <div class="section-content">
            <div class="content-items">
                <div class="content-item">
                    <div class="key">{{'TrackingNumber'|translate}}</div>
                    <div class="value">
                        <span>{{ isPendingShipment ? 'N/A' : (shipmentPackage?.TrackingNumber || 'N/A') }}</span>
                    </div>
                </div>
            </div>
            <div class="content-items" *ngIf="isEUUser">
                <div class="content-item">
                    <div class="key">{{'InitialTrackingNumber'|translate}}</div>
                    <div class="value">
                        <span>{{ isPendingShipment ? 'N/A' : (shipmentPackage?.InitialTrackingNumber || 'N/A') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <a (click)="toggleTrackingDetails($event)" class="link no-print" href="#">
            {{ (isShowTrackingDetailsTable ? 'ViewLess' : 'ViewDetails') | translate }}
        </a>
        <div [class.visible]="isShowTrackingDetailsTable" class="tracking-details-table">
            <table [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe" datatable>
                <thead>
                <tr>
                    <th>{{'Location'|translate}}</th>
                    <th>{{'Date'|translate}}</th>
                    <th>{{'LocalTime'|translate}}</th>
                    <th>{{'Description'|translate}}</th>
                    <th>{{'SignedBy'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let scan of trackingScans">
                    <td>{{ scan.City }}, {{ scan.StateProvinceCode }} {{ scan.CountryCode }}</td>
                    <td>{{ scan.ActivityDate | date:'mediumDate' }}</td>
                    <td>{{ scan.ActivityDate | date:'shortTime' }}</td>
                    <td>{{ scan.StatusTypeDescription }}</td>
                    <td>{{ scan.SignedForByName }}</td>
                </tr>
                </tbody>
            </table>
            <upsc-element-blocker *ngIf="isTrackingDetailsLoading"></upsc-element-blocker>
        </div>
    </div>
</ng-template>

<ng-template #shipmentDetails>
    <div *ngIf="shipmentType !== 'reported'" class="section shipment-details general-shipment-info-section">
        <div class="section-header">
            <h4 class="section-title">{{'ShipmentDetails'|translate}}</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section-content">
            <div class="content-items shipment-details">
                <div class="content-items-left">
                    <div class="content-item">
                        <span class="key">{{'ShipDate'|translate}}</span>
                        <span class="value">{{ simplifyDate(shipmentPackage?.ShipDate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'TrackingNumber'|translate}}</span>
                        <span class="value">{{ isPendingShipment ? 'N/A' : (shipmentPackage?.TrackingNumber || 'N/A') }}</span>
                    </div>
                    <div *ngIf="shipmentPackage?.ReturnLabel" class="content-item">
                        <span class="key">{{'returnTrackingNumber'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ReturnTrackingNumber || 'N/A' }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'confirmationNo'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ConfirmationNumber || 'N/A' }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'ReferenceNumber'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ReferenceNumber || 'N/A' }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'customerReferenceNo'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.CustomerReferenceNumber || 'N/A' }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'ParcelProNotify'|translate}}</span>
                        <span *ngIf="!shipmentPackage?.InternalTrackingNumber" class="value">N/A</span>
                        <a *ngIf="shipmentPackage?.InternalTrackingNumber"
                           [href]="'https://notify.parcelpro.com/track/' + shipmentPackage?.InternalTrackingNumber"
                           class="value"
                           target="_blank">
                            <span>{{ shipmentPackage?.InternalTrackingNumber }}</span>
                        </a>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'COD'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsCod ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                </div>
                <div class="content-items-right">
                    <div class="content-item">
                        <span class="key">{{'ServiceType'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ServiceCode | serviceType }}</span>
                    </div>
                    <div *ngIf="shipmentPackage?.ShipmentReason" class="content-item hide-me">
                        <span class="key">{{ 'ShipmentReason' | translate }}</span>
                        <span class="value">{{ shipmentPackage?.ShipmentReason || 'N/A' }}</span>
                    </div>
                    <div *ngIf="shipmentPackage?.CustomField" class="content-item">
                        <span class="key">{{ shipmentPackage?.CustomField }}</span>
                        <span class="value">{{ shipmentPackage?.CustomFieldValue || 'N/A' }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'PackageType'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.PackageCode | packageType }}</span>
                    </div>

                    @if (this.isEUUser && shouldShowPackageDetails) {
                        <div class="content-item">
                            <span class="key">{{ 'Length'|translate }}</span>
                            <span class="value">{{ shipmentPackage?.Length | packageType }}&nbsp;cm</span>
                        </div>
                        <div class="content-item">
                            <span class="key">{{ 'Width'|translate }}</span>
                            <span class="value">{{ shipmentPackage?.Width | packageType }}&nbsp;cm</span>
                        </div>
                        <div class="content-item">
                            <span class="key">{{ 'Height'|translate }}</span>
                            <span class="value">{{ shipmentPackage?.Height | packageType }}&nbsp;cm</span>
                        </div>
                    }

                    <div class="content-item">
                        <span class="key">{{'estimatedWeight'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.Weight | number: '1.2-2' }} {{ weightUOM }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'BillDutiesTaxesFees'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.BillDutiesToAccount || 'N/A'}}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'needsEEI'|translate}}</span>
                        <span class="value">{{ +shipmentPackage?.FilingOption === 0 ? ('No' | translate) : ('Yes' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'InsuredValue'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.InsuredValue | number: '1.2-2' }} {{ insuredValueCurrencyCode }}</span>
                    </div>
                    <div class="content-item" *ngIf = "isEUUser">
                        <span class="key">{{'EstimatedQuote'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.TotalCharges | number: '1.2-2' }} {{ insuredValueCurrencyCode }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #shipmentInformation>
    <div *ngIf="shipmentType !== 'reported'" class="section shipment-information general-shipment-info-section">
        <div class="section-header">
            <h4 class="section-title">{{'ShipmentInformation'|translate}}</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section-content">
            <div class="content-items shipment-information">
                <h2 class="content-items-title">{{'shipFrom'|translate}}</h2>
                <div class="content-item">
                    <span class="key">{{'ContactName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.FirstName + ' ' + shipmentPackage?.ShipFrom.LastName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'CompanyName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}} 2</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.ApartmentSuite }}</span>
                </div>
                <div class="content-item" *ngIf="isFRITUser">
                    <span class="key">{{'Address'|translate}} 3</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.AdditionalAddressInformation }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'City'|translate}}/{{'State'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.City + ', ' + shipmentPackage?.ShipFrom.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Zip'|translate}}/{{'Country'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFrom.Zip + ', ' + shipmentPackage?.ShipFrom.Country }}</span>
                </div>
            </div>
            <div class="content-items shipment-information">
                <h2 class="content-items-title">{{'shipTo'|translate}}</h2>
                <div class="content-item">
                    <span class="key">{{'ContactName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.FirstName + ' ' + shipmentPackage?.ShipTo.LastName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'CompanyName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}} 2</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.ApartmentSuite }}</span>
                </div>
                <div class="content-item" *ngIf="isFRITUser">
                    <span class="key">{{'Address'|translate}} 3</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.AdditionalAddressInformation }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'City'|translate}}/{{'State'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.City + ', ' + shipmentPackage?.ShipTo.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Zip'|translate}}/{{'Country'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipTo.Zip + ', ' + shipmentPackage?.ShipTo.Country }}</span>
                </div>
            </div>
            <div *ngIf="shipmentPackage?.IsShipFromRestrictedZip" class="content-items shipment-information">
                <h2 class="content-items-title">{{'shipFromReroute'|translate}}</h2>
                <div class="content-item">
                    <span class="key">{{'ContactName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.FirstName + ' ' + shipmentPackage?.ShipFromRerouting.LastName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'CompanyName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}} 2</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.ApartmentSuite }}</span>
                </div>
                <div class="content-item" *ngIf="isFRITUser">
                    <span class="key">{{'Address'|translate}} 3</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.AdditionalAddressInformation }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'City'|translate}}/{{'State'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.City + ', ' + shipmentPackage?.ShipFromRerouting.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Zip'|translate}}/{{'Country'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipFromRerouting.Zip + ', ' + shipmentPackage?.ShipFromRerouting.Country }}</span>
                </div>
            </div>
            <div *ngIf="shouldShowShipToReroute()" class="content-items shipment-information">
                <h2 class="content-items-title">{{'shipToReroute'|translate}}</h2>
                <div class="content-item">
                    <span class="key">{{'ContactName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.FirstName + ' ' + shipmentPackage?.ShipToRerouting.LastName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'CompanyName'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.CompanyName }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.StreetAddress }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Address'|translate}} 2</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.ApartmentSuite }}</span>
                </div>
                <div class="content-item" *ngIf="isFRITUser">
                    <span class="key">{{'Address'|translate}} 3</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.AdditionalAddressInformation }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'City'|translate}}/{{'State'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.City + ', ' + shipmentPackage?.ShipToRerouting.State }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'Zip'|translate}}/{{'Country'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipToRerouting.Zip + ', ' + shipmentPackage?.ShipToRerouting.Country }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentInformation>
    <div *ngIf="shipmentType !== 'reported'" class="tracked-shipment-info-section payment-information">
        <div class="section-header">
            <h4 class="section-title">{{'PaymentInformation'|translate}}</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section payment-information">
            <div class="section-content">
                <div class="content-items payment-information">
                    <div *ngIf="shouldShowBillToAccountNumber" class="content-item"> <!--*ngIf="!isReturnService"-->
                        <span class="key">{{'BillTo'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.BillToAccount }}</span>
                    </div>

                    <div class="content-item">
                        <span class="key">{{'EstimatedShippingInsurance'|translate}}</span>
                        <span class="value">{{ estimatedCost }}</span>
                    </div>
                    <ng-container>
                        <div *ngFor="let item of shipmentPackage?.Estimator[0]?.EstimatorDetail" class="content-item">
                            <span class="key">{{ item.AccessorialDescription }}</span>
                            <span class="value">{{ formatMoney(item.AccessorialFee) }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="section total-payment">
            <div class="section-content">
                <div class="content-items">
                    <div class="content-item total">
                        <span class="key">{{'YourTotal'|translate}}</span>
                        <span class="value">{{ totalCharges }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #alternativeDeliveryLocation>
    <div *ngIf="shipmentType !== 'reported' && shipmentPackage?.IsHoldAtLocation"
         class="tracked-shipment-info-section alternative-delivery-location">
        <div class="section-header">
            <h4 class="section-title">{{'shipmentDetails.alternativeDeliveryLocation.title'|translate}}</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="content-items payment-information">
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.consignee'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.HoldAtAddress2 }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.contactName'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ShipTo?.FirstName + ' ' + shipmentPackage?.ShipTo?.LastName }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.companyName'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ShipTo?.CompanyName }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.address'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.HoldAtAddress1 }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.address2'|translate}}</span>
                        <span class="value"></span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.cityState'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.HoldAtCity + ', ' + shipmentPackage?.HoldAtState }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.alternativeDeliveryLocation.zipCountryTerritory'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.HoldAtZip }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #specialServices>
    <div *ngIf="shipmentType !== 'reported'" class="tracked-shipment-info-section special-services">
        <div class="section-header">
            <h4 class="section-title">{{'shipmentDetails.specialServices.title'|translate}}</h4>
            <ng-container [ngTemplateOutlet]="shipmentEdit"></ng-container>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="content-items payment-information">
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.saturdayPickup'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsSaturdayPickUp ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.saturdayDelivery'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsSaturdayDelivery ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'DirectDeliveryOnly'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsDDO ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.adultSignatureRequired'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsDeliveryConfirmation ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.directSignatureRequired'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsDirectSignature ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.codService'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.CodAmount ? (shipmentPackage?.CodAmount | number: '1.2-2') + ' ' + insuredValueCurrencyCode : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.emailNotification'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.NotifySender ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.recipientNotifications'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.NotifyRecipient ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.thermalPrinter'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsThermal ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.returnLabelPrinted'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ReturnLabel ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.residentialDelivery'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.ShipToResidential ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item">
                        <span class="key">{{'shipmentDetails.specialServices.dropShipment'|translate}}</span>
                        <span class="value">{{ shipmentPackage?.IsDropShipment ? ('Yes' | translate) : ('No' | translate) }}</span>
                    </div>
                    <div class="content-item" *ngIf="customer?.DDEnabled === true && user?.CountryCode === 'US'">
                        <div [innerHTML]="'shipmentDetails.specialServices.DeliveryDefenseAddressConfidence' | translate"
                             class="key"></div>
                        <div class="value">{{ shipmentPackage?.UseDeliveryDefense || !!shipmentPackage?.DDScore ? ('Yes' | translate) : ('No' | translate) }}</div>
                    </div>

                    <!-- TEMP: [DD-307] Hide UPS Access Point for non-DD customers. -->
                    <ng-container *ngIf="customer?.DDEnabled !== null">
                    <div class="content-item" *ngIf="carrierCode === 'ups' && user?.CountryCode === 'US'">
                        <div class="key">
                            <span *ngIf="carrierCode === 'ups'"
                                  [innerHTML]="'shipmentDetails.specialServices.UPSAccessPoint' | translate"></span>
                        </div>
                        <div class="value">{{ shipmentPackage?.IsHoldAtLocation ? ('Yes' | translate) : ('No' | translate) }}</div>
                    </div>
                    </ng-container>
                    <div class="content-item" *ngIf="carrierCode === 'fedex' && user?.CountryCode === 'US'">
                        <div class="key">
                            <span *ngIf="carrierCode === 'fedex'"
                                  [innerHTML]="'shipmentDetails.specialServices.FedExHoldAtLocation' | translate"></span>
                        </div>
                        <div class="value">{{ shipmentPackage?.IsHoldAtLocation ? ('Yes' | translate) : ('No' | translate) }}</div>
                    </div>
                    <div *ngIf="shipmentPackage?.DispatchStatus !== 1">
                        <div *ngIf="shipmentPackage?.DispatchConfirmationNumber" class="content-item schedule-pickup">
                            <span class="key">{{'schedulePickup'|translate}}</span>
                            <span class="value"></span>
                        </div>
                        <div *ngIf="shipmentPackage?.DispatchConfirmationNumber" class="content-item">
                            <span class="key">{{'dispatchConfirmation'|translate}} #</span>
                            <span class="value">{{ shipmentPackage?.DispatchConfirmationNumber || 'N/A' }}</span>
                        </div>
                        <div *ngIf="shipmentPackage?.DispatchConfirmationNumber" class="content-item">
                            <span class="key">{{'Date'|translate}}</span>
                            <span class="value">{{ shipmentPackage?.PickUpDate | date:'mediumDate' || 'N/A' }}</span>
                        </div>
                        <div *ngIf="shipmentPackage?.DispatchConfirmationNumber" class="content-item">
                            <span class="key">{{'readyAt'|translate}}</span>
                            <span class="value">{{ shipmentPackage?.PickUpAtHour || '00' }}
                                :{{ shipmentPackage?.PickUpAtMinute || '00' }}</span>
                        </div>
                        <div *ngIf="shipmentPackage?.DispatchConfirmationNumber" class="content-item">
                            <span class="key">{{'pickupBy'|translate}}</span>
                            <span class="value">{{ shipmentPackage?.PickUpByHour || '00' }}
                                :{{ shipmentPackage?.PickUpByMinute || '00' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #restrictedZipCodeNotification>
    <div *ngIf="shipmentType !== 'reported'" class="section notifications no-print restricted-zip-code">
        <div *ngIf="shouldShowRestrictedZipCodeMessage()" class="notification alert reroute">
            <div class="notification-content">
                <h5>{{ 'DestinationZipCodeRestricted' | translate }}</h5>
                <p [innerHTML]="'DestinationZipCodeRestrictedNotification' | translate"> </p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notifications>
    <div *ngIf="shipmentType !== 'reported'" class="section notifications no-print">
        <div *ngIf="shipmentPackage?.IsHighValueShipment && shipmentPackage?.Status === 0"
             class="notification alert high-value">
            <div class="notification-content">
                <h5>{{ 'HighValueShipmentNotification.Title' | translate }}</h5>
                <p>{{ 'HighValueShipmentNotification.Message' | translate }}</p>
            </div>
        </div>
        <div *ngIf="shipmentPackage?.EeiFilingOption === '1'" class="notification alert aes">
            <div class="notification-content">
                <h5>{{ 'AESShipmentNotification.Title' | translate }}</h5>
                <p>{{ 'AESShipmentNotification.Message' | translate }}</p>
            </div>
        </div>
        <div *ngIf="shipmentPackage?.IsShipToHasRestrictedWords || shipmentPackage?.IsShipFromHasRestrictedWords"
             class="notification alert restricted-words">
            <div class="notification-content">
                <h5>{{ 'RestrictedWordsFound.Title' | translate }}</h5>
                <p>{{ 'RestrictedWordsFound.Message' | translate }}</p>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #commodities>
    <div *ngIf="shipmentPackage?.Commodities && shipmentPackage?.Commodities?.length && shipmentType !== 'reported'"
         class="section commodities">
        <div class="section-title">{{'Commodities'|translate}}</div>
        <div class="section-content">
            <div class="content-items">
                <div class="content-item">
                    <span class="key">{{'ShipmentPurpose'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.ShipmentPurpose }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'numberOfCommodities'|translate}}</span>
                    <span class="value">{{ shipmentPackage?.Commodities?.length || 0 }}</span>
                </div>
                <div class="content-item">
                    <span class="key">{{'TotalCustoms'|translate}}</span>
                    <span class="value">
                        <span>{{ formatMoneyWithoutDefaultCurrency(getTotalCommodityValue(), null) }}</span>
                        <span>&nbsp;{{ commodityCurrencyCode }}</span>
                    </span>
                </div>
            </div>

            <table [dtOptions]="dtOptions" class="stripe" datatable>
                <thead>
                <tr>
                    <th>{{'Commodity'|translate}}</th>
                    <th class="text-center">{{'Quantity'|translate}}</th>
                    <th class="text-center">{{'Weight'|translate}}</th>
                    <th class="text-center">{{'CustomsValue'|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let commodity of shipmentPackage?.Commodities">
                    <td>{{ commodity.CommodityDescription }}</td>
                    <td class="text-center">{{ commodity.Quantity }}</td>
                    <td class="text-center">
                        <span>{{ commodity.Weight | number:'1.2-2' }}</span>
                        <span *ngIf="commodity.HarmonizedCode">{{ weightUOM }}</span>
                    </td>
                    <td class="text-center">
                        <span>{{ formatMoneyWithoutDefaultCurrency(commodity.CustomsValue, null) }}</span>
                        <span *ngIf="commodity.HarmonizedCode">&nbsp;{{ commodityCurrencyCode }}</span>
                    </td>
                </tr>
                <tr class="footer">
                    <td></td>
                    <td></td>
                    <td class="text-right">{{'Total'|translate}}</td>
                    <td class="text-center">
                        <span>{{ formatMoneyWithoutDefaultCurrency(getTotalCommodityValue(), null) }}</span>
                        <span>&nbsp;{{ commodityCurrencyCode }}</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>

<ng-template #shipmentEdit>
    <span (click)="showEditConfirmationDialog($event)"
          *ngIf="isAllowEditShipment && false"
          class="shipment-edit">
        {{ "shipmentDetails.edit" | translate }}
    </span>
</ng-template>
